import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import styles from "../../asset/Portfolio/Portfolio.module.scss";
import img1 from "../../asset/homefour/artworkprotofolio/artwork1.webp";
import img2 from "../../asset/homefour/artworkprotofolio/artwork2.webp";
import img3 from "../../asset/homefour/artworkprotofolio/artwork3.webp";
import img4 from "../../asset/homefour/artworkprotofolio/artwork4.webp";
import img5 from "../../asset/homefour/artworkprotofolio/artwork5.webp";
import img6 from "../../asset/homefour/artworkprotofolio/artwork6.webp";
import img7 from "../../asset/homefour/artworkprotofolio/artwork7.webp";



import edit1 from "../../asset/homefour/imageedit/artwork1.webp";
import edit2 from "../../asset/homefour/imageedit/artwork2.webp";
import edit3 from "../../asset/homefour/imageedit/artwork3.webp";
import edit4 from "../../asset/homefour/imageedit/artwork4.webp";

import emb1 from "../../asset/homefour/RegularEmbroidery/artwork1.webp";
import emb2 from "../../asset/homefour/RegularEmbroidery/artwork2.webp";
import emb3 from "../../asset/homefour/RegularEmbroidery/artwork3.webp";
import emb4 from "../../asset/homefour/RegularEmbroidery/artwork4.webp";
import emb5 from "../../asset/homefour/RegularEmbroidery/artwork5.webp";
import emb6 from "../../asset/homefour/RegularEmbroidery/artwork6.webp";
import emb7 from "../../asset/homefour/RegularEmbroidery/artwork7.webp";
import emb8 from "../../asset/homefour/RegularEmbroidery/artwork8.webp";
import emb9 from "../../asset/homefour/RegularEmbroidery/artwork9.webp";

import rep1 from "../../asset/homefour/protofolionamedrop/artwork1.webp";
import rep2 from "../../asset/homefour/protofolionamedrop/artwork2.webp";
import rep3 from "../../asset/homefour/protofolionamedrop/artwork3.webp";
import rep4 from "../../asset/homefour/protofolionamedrop/artwork4.webp";
import rep5 from "../../asset/homefour/protofolionamedrop/artwork5.webp";






import cat1 from "../../asset/homefour/printdesign/artwork1.png";
import cat2 from "../../asset/homefour/printdesign/artwork2.png";
import cat3 from "../../asset/homefour/printdesign/artwork3.png";
import cat4 from "../../asset/homefour/printdesign/artwork4.png";


import td1 from "../../asset/homefour/3d/001.webp";
import td2 from "../../asset/homefour/3d/002.webp";
import td3 from "../../asset/homefour/3d/003.webp";
import td4 from "../../asset/homefour/3d/004.webp";
import td5 from "../../asset/homefour/3d/005.webp";
import td6 from "../../asset/homefour/3d/006.webp";



import mock1 from "../../asset/homefour/mockup/artwork1.webp";
import mock2 from "../../asset/homefour/mockup/artwork2.webp";
import mock3 from "../../asset/homefour/mockup/artwork3.webp";
import mock4 from "../../asset/homefour/mockup/artwork4.webp";
import mock5 from "../../asset/homefour/mockup/artwork5.webp";


import creative1 from "../../asset/homefour/creative/artwork1.webp";
import creative2 from "../../asset/homefour/creative/artwork2.webp";
import creative3 from "../../asset/homefour/creative/artwork3.webp";
import creative4 from "../../asset/homefour/creative/artwork4.webp";
import creative5 from "../../asset/homefour/creative/artwork5.webp";
import creative6 from "../../asset/homefour/creative/artwork6.webp";



import patch1 from "../../asset/homefour/patches/artwok1.webp";
import patch2 from "../../asset/homefour/patches/artwok2.webp";
import patch3 from "../../asset/homefour/patches/artwok3.webp";
import patch4 from "../../asset/homefour/patches/artwok4.webp";
import patch5 from "../../asset/homefour/patches/artwok5.webp";
import patch6 from "../../asset/homefour/patches/artwork6.webp";

import app1 from "../../asset/homefour/applique/001.webp";
import app2 from "../../asset/homefour/applique/002.webp";
import app3 from "../../asset/homefour/applique/003.webp";
import app4 from "../../asset/homefour/applique/004.webp";
import app5 from "../../asset/homefour/applique/005.webp";

import mascot1 from "../../asset/homefour/mascots/artwork1.webp";
import mascot2 from "../../asset/homefour/mascots/artwork2.webp";
import mascot3 from "../../asset/homefour/mascots/artwork3.webp";
import mascot4 from "../../asset/homefour/mascots/artwork4.webp";
import mascot5 from "../../asset/homefour/mascots/artwork5.webp";


import custom1 from "../../asset/homefour/customdesign/artwork1.webp";
import custom2 from "../../asset/homefour/customdesign/artwork2.webp";
import custom3 from "../../asset/homefour/customdesign/artwork3.webp";


import nemb1 from "../../asset/homefour/embroidery/artwork1.webp";
import nemb2 from "../../asset/homefour/embroidery/artwork2.webp";
import nemb3 from "../../asset/homefour/embroidery/artwork3.webp";
import nemb4 from "../../asset/homefour/embroidery/artwork4.webp";
import nemb5 from "../../asset/homefour/embroidery/artwork5.webp";



import sep1 from "../../asset/homefour/Separationsprintdesign/001.webp";
import sep2 from "../../asset/homefour/Separationsprintdesign/002.webp";
import sep3 from "../../asset/homefour/Separationsprintdesign/003.webp";
import sep4 from "../../asset/homefour/Separationsprintdesign/004.webp";
import sep5 from "../../asset/homefour/Separationsprintdesign/005.webp";
import sep6 from "../../asset/homefour/Separationsprintdesign/006.webp";


import label1 from "../../asset/homefour/Labelsscaling/001.webp";
import label2 from "../../asset/homefour/Labelsscaling/002.webp";
import label3 from "../../asset/homefour/Labelsscaling/003.webp";
import label4 from "../../asset/homefour/Labelsscaling/004.webp";

import bannerImg from '../../asset/homefour/about.webp';
import Breadcrumb from "../Breadcrumb/Breadcrumb";

const portfolioData = {
  1: {
    title: "Vector Conversions",
    category: "Artwork",
    image: img1,
    images: [img1, img2, img3, img4, img5, img6, img7],
    description: "Professional vector conversion services for all your artwork needs.",
    details: "High-quality vector conversions that maintain the integrity of your original designs.",
  },
  2: {
    title: "Regular Embroidery",
    category: "Digitizing",
    image: emb1,
    images: [emb1, emb2, emb3, emb4, emb5, emb6, emb7, emb8, emb9],
    description: "Expert embroidery digitizing services.",
    details: "Transform your designs into high-quality embroidery files.",
  },
  3: {
    title: "Replication",
    category: "Namedrop",
    image: rep1,
    images: [rep1, rep2, rep3, rep4, rep5],
    description: "Precise replication services for your projects.",
    details: "Accurate reproduction of designs with attention to detail.",
  },
  4: {
    title: "Catalogs",
    category: "Print Design",
    image: cat1,
    images: [cat1, cat2, cat3, cat4],
    description: "Professional catalog design and layout services.",
    details: "Create stunning catalogs that showcase your products effectively.",
  },
  5: {
    title: "Image Edit",
    category: "Artwork",
    image: img5,
    images: [edit1, edit2, edit3, edit4],
    description: "Professional image editing and enhancement.",
    details: "Expert photo editing to bring your images to life.",
  },
  6: {
    title: "Puff & 3D Embroidery",
    category: "Digitizing",
    image: td1,
    images: [td1, td2, td3, td4, td5, td6],
    description: "Specialized 3D and puff embroidery digitizing.",
    details: "Create dimensional effects with our advanced digitizing techniques.",
  },
  7: {
    title: "Mockup",
    category: "Artwork",
    image: mock1,
    images: [mock1, mock2, mock3, mock4, mock5],
    description: "Professional mockup design services.",
    details: "Create realistic mockups to showcase your designs effectively.",
  },
  8: {
    title: "Creative",
    category: "Artwork",
    image: creative1,
    images: [creative1, creative2, creative3, creative4, creative5, creative6],
    description: "Creative design solutions for your brand.",
    details: "Innovative and unique creative designs tailored to your needs.",
  },
  9: {
    title: "Applique",
    category: "Digitizing",
    image: app1,
    images: [app1, app2, app3, app4, app5],
    description: "Expert applique digitizing services.",
    details: "Professional applique designs for unique embroidery effects.",
  },
  10: {
    title: "Patches & Badges",
    category: "Digitizing",
    image: patch1,
    images: [patch1, patch2, patch3, patch4, patch5, patch6],
    description: "Custom patches and badges digitizing.",
    details: "High-quality patch and badge designs for all applications.",
  },
  11: {
    title: "Mascots & Icons",
    category: "Namedrop",
    image: mascot1,
    images: [mascot1, mascot2, mascot3, mascot4, mascot5],
    description: "Custom mascot and icon designs.",
    details: "Create memorable mascots and icons for your brand.",
  },
  12: {
    title: "Custom Design",
    category: "Namedrop",
    image: custom1,
    images: [custom1, custom2, custom3],
    description: "Tailored custom design solutions.",
    details: "Unique designs crafted specifically for your needs.",
  },
  13: {
    title: "Embroidery",
    category: "Namedrop",
    image: nemb1,
    images: [nemb1, nemb2, nemb3, nemb4, nemb5],
    description: "Professional embroidery design services.",
    details: "Expert embroidery designs for all your projects.",
  },
  14: {
    title: "Labels & Scaling",
    category: "Print Design",
    image: label1,
    images: [label1, label2, label3, label4],
    description: "Professional label design and scaling services.",
    details: "Create perfect labels with precise scaling for any application.",
  },
  // 15: {
  //   title: "Brochure & Flyer",
  //   category: "Print Design",
  //   image: img6,
  //   description: "Eye-catching brochure and flyer designs.",
  //   details: "Professional marketing materials that capture attention.",
  // },
  16: {
    title: "Separations",
    category: "Print Design",
    image: sep1,
    images: [sep1, sep2, sep3, sep4, sep5, sep6],
    description: "Expert color separation services.",
    details: "Precise color separations for high-quality printing.",
  },
};

const PortfolioDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const project = portfolioData[id];
  const [isLoaded, setIsLoaded] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsLoaded(true);
  }, []);

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % project.images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + project.images.length) % project.images.length);
  };

  if (!project) {
    return <div>Project not found</div>;
  }

  return (
    <div className={`${styles.detailPage} ${isLoaded ? styles.fadeIn : ''}`}>
     



      <div className={styles.detailContent}>
        <div className={styles.breadcrumbWrapper}>
          <span
            className={styles.breadcrumbPill}
            onClick={() => navigate("/")}
          >
            Home
          </span>

          <span className={styles.breadcrumbSlash}>/</span>

          <span
            className={styles.breadcrumbPill}
            onClick={() => navigate("/portfolio")}
          >
            Portfolio
          </span>

          <span className={styles.breadcrumbSlash}>/</span>

          <span className={`${styles.breadcrumbPill} ${styles.active}`}>
            {project.title}
          </span>
        </div>

        <p className={styles.category}>{project.category}</p>
        <p className={styles.description}>{project.description}</p>
        <p className={styles.details}>{project.details}</p>


        {project.images ? (
          <>
            <div className={styles.imageGallery}>
              {project.images.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`${project.title} ${index + 1}`}
                  className={styles.galleryImage}
                  onClick={() => openLightbox(index)}
                />
              ))}
            </div>

            {lightboxOpen && (
              <div className={styles.lightbox} onClick={closeLightbox}>
                <button className={styles.closeBtn} onClick={closeLightbox}>&times;</button>
                <button className={styles.prevBtn} onClick={(e) => { e.stopPropagation(); prevImage(); }}>&larr;</button>
                <img
                  src={project.images[currentImageIndex]}
                  alt={`${project.title} ${currentImageIndex + 1}`}
                  className={styles.lightboxImage}
                  onClick={(e) => e.stopPropagation()}
                />
                <button className={styles.nextBtn} onClick={(e) => { e.stopPropagation(); nextImage(); }}>&rarr;</button>
                <div className={styles.imageCounter}>{currentImageIndex + 1} / {project.images.length}</div>
              </div>
            )}
          </>
        ) : (
          <img src={project.image} alt={project.title} className={styles.detailImage} />
        )}
      </div>
    </div>
  );
};

export default PortfolioDetail;
